import React, {
  FormEvent,
  Fragment,
  useContext,
  useRef,
  useState,
} from "react";
// Importing the CSS File for the filter form
import styled from "styled-components";
import { AppContext } from "./AppContext";

const Checkbox = styled.input`
  & {
    position: absolute;
    opacity: 0;
    cursor: pointer;
    height: 0;
    width: 0;
  }

  &::placeholder {
    font-family: "Avenir Next", Arial, sans-serif !important;
  }
  &::-moz-placeholder {
    font-family: "Avenir Next", Arial, sans-serif !important;
  }
`;

const SelectedCheckbox = styled.input`
  & {
    position: absolute;
    opacity: 0;
    cursor: pointer;
    height: 0;
    width: 0;
  }
  &::placeholder {
    font-family: "Avenir Next", Arial, sans-serif !important;
  }
  &::-moz-placeholder {
    font-family: "Avenir Next", Arial, sans-serif !important;
  }
`;

export const RadioInput = (props: {
  handleClick: (e: any) => void;
  value: string;
  checked?: boolean;
  className?: string;
}) => {
  const purpleColor = "#522398";
  // RGB version of the purple color
  const rgbPurpleColor = "rgb(82, 35, 152)";

  const [toggleSelect, setToggleSelect] = useState(false);

  const InputRef = useRef() as React.MutableRefObject<HTMLInputElement>;

  const selectedInputRef = useRef<HTMLInputElement>();

  const unSelectedInputRef = useRef<HTMLInputElement>();

  const { productFiltersGlobal } = useContext(AppContext);

  const changeStoreFontToBold = () => {
    setToggleSelect(true);

    const parentElement = InputRef.current.parentElement;

    const parentElementStyles = parentElement?.style;

    const attribute = InputRef.current.getAttribute(
      "data-storeLocatorReact-selected"
    );

    // @ts-ignore
    parentElementStyles.fontWeight = 700;
    // @ts-ignore
    parentElementStyles.color = purpleColor;
  };

  const changeStoreFontToNormal = () => {
    setToggleSelect(false);

    const parentElement = InputRef.current.parentElement;

    const parentElementStyles = parentElement?.style;

    const attribute = InputRef.current.getAttribute(
      "data-storeLocatorReact-selected"
    );

    InputRef.current.checked = false;

    // @ts-ignore
    parentElementStyles.fontWeight = "normal";
    // @ts-ignore
    parentElementStyles.color = "black";
  };

  return (
    <Fragment>
      {toggleSelect ? (
        <SelectedCheckbox
          onClick={(e: FormEvent) => {
            setToggleSelect(false);
            props.handleClick(e);
          }}
          onChange={(e: FormEvent) => props.handleClick(e)}
          value={props.value}
          type="radio"
          ref={InputRef}
          data-storeLocatorReact-selected={"selected"}
          checked={props.checked ? true : false}
        />
      ) : (
        <Checkbox
          onClick={(e: FormEvent) => {
            setToggleSelect(true);
            props.handleClick(e);
          }}
          onChange={(e: FormEvent) => props.handleClick(e)}
          value={props.value}
          type="radio"
          ref={InputRef}
          data-storeLocatorReact-selected={"not selected"}
          checked={props.checked ? true : false}
        />
      )}
    </Fragment>
  );
};

export default RadioInput;
